/**
 * Created by Daniel
 * Description:
 *
 * ---------maintenance history-------------
 */

import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { ContextMenuConfig, ContextMenuShowAction } from '../../widgets/tam-context-menu/tam-context-menu.model';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'sort',
    templateUrl: './sort.component.html',
    styleUrls: ['./sort.component.scss']
})
export class SortComponent implements OnInit {
    @Input() sortInfo;
    @Input() isDraft: boolean;
    @Input() sortChangeSubject: Subject<any>;
    @Output() change = new EventEmitter();
    sortContextMenuConfig: ContextMenuConfig;

    constructor() { }

    ngOnInit() {
        this.initContextMenu();
        this.changeSortInfo(null);

        this.sortChangeSubject.subscribe(event => {
            this.changeSortInfo(event);
        });
    }

    changeSortInfo(event) {
        if (event) {
            this.sortInfo = event;
        }
        if (this.sortInfo) {
            if (this.sortInfo.sortBy) {
                this.sortContextMenuConfig.items[0].checked = false;
                this.sortContextMenuConfig.items[1].checked = false;
                this.sortContextMenuConfig.items[2].checked = false;
                this.sortContextMenuConfig.items.forEach(item => {
                    if (item.sortBy === this.sortInfo.sortBy) {
                        item.checked = true;
                    }
                });
            }
            if (this.sortInfo.sortOrder) {
                this.sortContextMenuConfig.items[4].checked = false;
                this.sortContextMenuConfig.items[5].checked = false;
                this.sortContextMenuConfig.items.forEach(item => {
                    if (item.sortOrder === this.sortInfo.sortOrder) {
                        item.checked = true;
                    }
                });
            }
        }
    }

    initContextMenu() {
        this.sortContextMenuConfig = new ContextMenuConfig();
        this.sortContextMenuConfig.single = true;
        this.sortContextMenuConfig.showItemIcon = false;
        if (!this.isDraft) {
            this.sortContextMenuConfig.items = [
                { id: 0, text: 'Display Date', sortBy: 'displayDate', checked: true },
                { id: 1, text: 'Submitted Date', sortBy: 'submittedDate' },
                { id: 2, text: 'Last Modified Date', sortBy: 'lastModifiedDate' },
                { divider: true },
                { id: 4, text: 'Newest to Oldest', sortOrder: 'desc', checked: true },
                { id: 5, text: 'Oldest to Newest', sortOrder: 'asc' }
            ];
        } else {
            this.sortContextMenuConfig.items = [
                { id: 0, text: 'Last Modified Date', sortBy: 'lastModifiedDate', checked: true },
                { id: 1, text: 'Created Date', sortBy: 'submittedDate' },
                { id: 2, text: 'Display Date', sortBy: 'displayDate' },
                { divider: true },
                { id: 4, text: 'Newest to Oldest', sortOrder: 'desc', checked: true },
                { id: 5, text: 'Oldest to Newest', sortOrder: 'asc' }
            ];
        }

        this.sortContextMenuConfig.events$.subscribe(event => this.onSortMenuSelect(event));
    }

    onSortMenuSelect(event) {
        let changeStatus = true;
        const sortItems = this.sortContextMenuConfig.items;

        for (let i = 0; i < sortItems.length; i++) {
            if (sortItems[i].checked && sortItems[i].id === event.payload.id) {
                changeStatus = false;
                break;
            }
        }

        if (changeStatus) {
            if (event.payload.id < 4) {
                this.sortContextMenuConfig.items[0].checked = false;
                this.sortContextMenuConfig.items[1].checked = false;
                this.sortContextMenuConfig.items[2].checked = false;
                this.sortContextMenuConfig.items[event.payload.id].checked = true;
            } else {
                this.sortContextMenuConfig.items[4].checked = false;
                this.sortContextMenuConfig.items[5].checked = false;
                this.sortContextMenuConfig.items[event.payload.id].checked = true;
            }
            event.payload.data = this.sortContextMenuConfig.items[event.payload.id];
            this.change.emit(event);
        }
    }

    showSortContextMenu(e: MouseEvent) {
        this.sortContextMenuConfig.show$.next(new ContextMenuShowAction(e, ''));
    }
}
